import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Select, Input, Tabs, Row, Col, Spin, message } from 'antd';
import Text from '../../../basicElement/Text';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import { getMatchOption } from '../../../shared/selectFn';
import format from '../../../shared/format';

const { TabPane } = Tabs;
const { Option } = Select;
const Panes = [{
    title: '带教奖上报',
    key: '0'
}, {
    title: '出师奖上报',
    key: '1'
}];

function RewardSituation(props, context) {
    const { data, disabled, onChange } = props;
    const { situation, failureReason } = context;
    const { name: reportInfoName } = getMatchOption(situation, 'code', data.reportInfo);
    const { name: reportFailReasonName } = getMatchOption(failureReason, 'code', data.reportFailReason);

    const situationOption = situation.map(i => <Option key={i.code}>{i.name}</Option>);
    const failureReasonOption = failureReason.map(i => <Option key={i.code}>{i.name}</Option>);
    return (
        <div style={{ marginTop: -16, padding: '20px 0', border: '1px solid #d9d9d9', borderTop: 'none' }}>
            <Row>
                <Col span={9}><Text colon={true}>上报情况</Text></Col>
                <Col offset={1} span={14}>
                    <Select
                        placeholder="请选择"
                        style={{width: 180}}
                        disabled={disabled}
                        value={format('toString', data.reportInfo)}
                        onChange={value => onChange(value, 'reportInfo')}
                    >
                        {situationOption}
                    </Select>
                </Col>
            </Row>
            {
                (reportInfoName === '暂不符合上报要求' || reportInfoName === '不符合上报要求') &&
                <Row>
                    <Col span={9}><Text colon={true}>没有上报成功的原因</Text></Col>
                    <Col offset={1} span={14}>
                        <Select
                            placeholder="请选择"
                            style={{width: 180}}
                            value={format('toString', data.reportFailReason)}
                            onChange={value => onChange(value, 'reportFailReason')}
                        >
                            {failureReasonOption}
                        </Select>
                    </Col>
                </Row>
            }
            {
                reportFailReasonName === '其他' &&
                <Row>
                    <Col offset={10} span={14}>
                        <Input
                            placeholder="请填写其他备注"
                            style={{width: 180}}
                            value={data.comment}
                            onChange={e => onChange(e.target.value, 'comment')}
                        />
                    </Col>
                </Row>
            }
        </div>
    );
}

RewardSituation.contextTypes = {
    situation: PropTypes.array,
    failureReason: PropTypes.array,
};

export default class RewardReport extends Component {
    static contextTypes = {
        situation: PropTypes.array,
        failureReason: PropTypes.array,
    }

    state = {
        loading: false,
        visible: false,
        record: {},
        data: { reward: {} },
        teacherList: [],
        activeKey: '0',
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.data.teacherId && prevState.data.teacherId !== this.state.data.teacherId) {
            this.queryReward();
        }
    }

    queryTeacher = () => {
        const { record: { userId } } = this.state;
        Fetch.post(API_URL.user.queryUserTeacherByUserId, {
            userId
        }).then(res => {
            const teacherList = res.list || [];
            this.setDefaultTeacher(teacherList);
            this.setState({ teacherList });
        }).catch(err => {
            console.error(err);
        });
    }
    
    queryReward = () => {
        const { current } = this.props;
        const { record: { userId }, data } = this.state;
        const { teacherId } = data;
        Fetch.post(API_URL.teaching.queryUserTeacherRewardInfoByParams, {
            userId,
            teacherId,
            rewardTargetType: current,
        }).then(res => {
            const { data: { rewardList } } = res;
            if (rewardList) {
                data.reward = [];
                rewardList.forEach(i => {
                    data.reward[i.rewardType - 1] = {
                        reportInfo: i.reportInfo,
                        reportFailReason: i.reportFailReason,
                        comment: i.comment,
                    };
                });
                this.setState({ data });
            }
        }).catch(err => {
            console.error(err);
        });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
            data: { reward: {} },
            teacherList: [],
            activeKey: '0',
        }, () => {
            this.queryTeacher();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    setDefaultTeacher = (list) => {
        let target;
        if (list.length === 1) {
            target = list[0];
        } else {
            target = list.find(i => i.isMain === 1) || {};
        }
        const { data } = this.state;
        const newData = {...data};
        newData.teacherId = target.teacherId;
        this.setState({ data: newData });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        const newData = {...data};
        newData[key] = value;
        newData.reward = [];
        this.setState({ data: newData });
    }

    handleItemChange = (value, key) => {
        const { activeKey, data } = this.state;
        const newData = {...data};
        if (!newData.reward[activeKey]) {
            newData.reward[activeKey] = {};
        }
        const target = newData.reward[activeKey];
        switch (key) {
            case 'reportInfo':
                target[key] = value;
                target.reportFailReason = undefined;
                target.comment = undefined;
                break;
            case 'reportFailReason':
                target[key] = value;
                target.comment = undefined;
                break;
            default:
                target[key] = value;
                break;
        }
        this.setState({ data: newData });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    submit = () => {
        const { failureReason } = this.context;
        const { current } = this.props;
        const { record, data } = this.state;
        const { userId } = record;
        const { teacherId, reward } = data;
        const keys = Object.keys(reward);
        if (!keys.length) {
            this.hide();
            return;
        }

        const params = {};
        for (let i = 0, len = keys.length; i < len; i++) {
            const key = +keys[i];
            const { reportInfo, reportFailReason, comment } = reward[key] || {};
            params[`reportInfo${key + 1}`] = reportInfo || '';
            params[`reportFailReason${key + 1}`] = reportFailReason || '';
            params[`comment${key + 1}`] = comment || '';
        }
        params.userId = userId;
        params.teacherId = teacherId;
        params.rewardTargetType = current;

        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.addUserTeacherReward, {
            ...params
        }).then(res => {
            message.success('上报成功！');
            this.hide();
            this.setState({ loading: false }, () => {
                this.props.loadData();
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getContent = ({ key }) => {
        const { data, activeKey } = this.state;
        if (key === activeKey) {
            const { teacherId, reward } = data;
            return (
                <RewardSituation
                    disabled={!teacherId}
                    data={reward[activeKey] || {}}
                    onChange={this.handleItemChange}
                />
            );
        } else {
            return null;
        }
    }

    render() {
        const { loading, visible, record, teacherList, activeKey, data } = this.state;
        const { userCompellation, employeeCode } = record;
        const teacherOption = teacherList.map(i => <Option key={i.teacherId}>{i.teacherName}({i.teacherCode}){i.isMain === 1 && '(主)'}</Option>);
        return (
            <Modal
                title="奖励上报"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <Spin spinning={loading}>
                    <div className="historyContractRecordUpdate">
                        <Row>
                            <Col span={9}><Text colon={true}>人员</Text></Col>
                            <Col offset={1} span={14}>{userCompellation}[{employeeCode}]</Col>
                        </Row>
                        <Row>
                            <Col span={9}><Text colon={true}>带教老师</Text></Col>
                            <Col offset={1} span={14}>
                                <Select
                                    placeholder="请选择"
                                    style={{width: 180}}
                                    value={format('toString', data.teacherId)}
                                    onChange={value => this.handleChange(value, 'teacherId')}
                                >
                                    {teacherOption}
                                </Select>
                            </Col>
                        </Row>
                        <Tabs activeKey={activeKey} onChange={this.handleTabsChange} type="card">
                            {Panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{this.getContent(pane)}</TabPane>)}
                        </Tabs>
                    </div>
                </Spin>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/components/RewardReport.js